import React from "react";
import useExportBookMetrics from "api/AdminDashboardResource/useExportBookMetrics";

const BookMetricsExportPanel = () => {
	const { mutate: exportMetrics, isLoading } = useExportBookMetrics();
	const [from, setFrom] = React.useState("");
	const [to, setTo] = React.useState("");

	const onSubmit = (e) => {
		e.preventDefault();
		// if (!from || !to) return;
		exportMetrics({ from, to });
	};

	return (
		<div
			id="book-metrics-export"
			className="bg-white rounded-2xl p-4 md:p-6 shadow-lg"
		>
			<h3 className="text-lg font-semibold mb-4">Export book visits report</h3>
			<form
				onSubmit={onSubmit}
				className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end"
			>
				<div>
					<label className="block text-sm text-gray-600 mb-1">From</label>
					<input
						type="date"
						className="w-full border rounded px-3 py-2"
						value={from}
						onChange={(e) => setFrom(e.target.value)}
					/>
				</div>
				<div>
					<label className="block text-sm text-gray-600 mb-1">To</label>
					<input
						type="date"
						className="w-full border rounded px-3 py-2"
						value={to}
						onChange={(e) => setTo(e.target.value)}
					/>
				</div>
				<div className="md:col-span-2">
					<button
						type="submit"
						disabled={isLoading}
						className="px-4 py-2 rounded bg-akgreener text-white disabled:opacity-50"
					>
						{isLoading ? "Generating..." : "Download Excel"}
					</button>
				</div>
			</form>
		</div>
	);
};

export default BookMetricsExportPanel;
